import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  package: {
    data: [],
    meta: {
      total: 0,
    },
  },
  mainPackage: [],
};

// TODO: fetch all the package
export const fetchPackage = createAsyncThunk(
  "fetchPackage/package",
  async ({ enqueueSnackbar, limit = 10, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`plans`, {
        params: {
          limit,
          page: page + 1,
        },
      });


      return {
        data: response.data.data,
        meta: {
          total: response.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create packages
export const createPackage = createAsyncThunk(
  "createPackage/package",
  async (
    { data, enqueueSnackbar, handleClose, activeTab, setActiveTab },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.post(`plans`, data);

      thunkApi.dispatch(fetchPackage({ limit: 10, page: 0 }));
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        activeTab,
        setActiveTab,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update packages
export const updatePackage = createAsyncThunk(
  "updatePackage/package",
  async ({ image, data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`plans/${id}`, data);

      thunkApi.dispatch(fetchPackage({ limit: 10, page: 0 }));
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        image,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete packages
export const deletePackage = createAsyncThunk(
  "deletePackage/package",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`plans/${id}`);
      thunkApi.dispatch(fetchPackage({ limit: 10, page: 0 }));

      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const packagelice = createSlice({
  name: "packages",
  initialState,
  reducers: {
    resetLoadings: (state) => {
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: get packages
    builder.addCase(fetchPackage.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchPackage.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.package = action.payload;
      state.mainPackage = state.package?.data?.filter?.(
        (cat) => cat?.parent_id === null
      );
    });

    builder.addCase(fetchPackage.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create packages
    builder.addCase(createPackage.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createPackage.fulfilled, (state, action) => {
      state.isLoading = false;
      state.package.data = [action.payload.data, ...state.package.data];
      state.package.meta.total = state.package.meta.total + 1;
      action.payload.enqueueSnackbar("Packages is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createPackage.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update packages
    builder.addCase(updatePackage.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updatePackage.fulfilled, (state, action) => {
      state.isLoading = false;
      if (!action.payload.image) {
        state.package.data = state.package.data.map((packages) => {
          if (packages.id === action.payload.data.id) {
            return action.payload.data;
          } else {
            return packages;
          }
        });
      }
      // action.payload.image &&  window.location.reload()
      action.payload.enqueueSnackbar("Packages is updated successfully.", {
        variant: "success",
      });

      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updatePackage.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete packages
    builder.addCase(deletePackage.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deletePackage.fulfilled, (state, action) => {
      state.isLoading = false;
      state.package.data = state.package.data.filter(
        (packages) => packages.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("Packages is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deletePackage.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default packagelice.reducer;

export const { resetLoadings } = packagelice.actions;
